/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Vue, Component } from 'vue-property-decorator';
import FreeModal from '../components/StayStrategy/FreeModal';
import { handlePayment } from '@/modules/common/helps';
import { promiseLock } from '@/lib/decorates';
import trackerLoaded from '@/lib/tracker';
import { getJWT } from '@/lib/util';

export const eventBus = new Vue();

const commonAttr = {
  tracking_scene: '中节点截流2',
  userid_: (getJWT() && getJWT().id) || 0,
  url: window.location.href,
};

// 需要传price字段
const needPrice = [
  'landingpage_paid_page_view',
  'landingpage_paid_enroll_click',
  'landingpage_paid_prepay',
  'landingpage_paid_popup',
  'landingpage_paid_popup_enroll_click',
  'landingpage_paid_popup_quit',
  'landingpage_paid_popup_prepay',
  'landingpage_enroll',
  'landingpage_free_page_view',
];

enum PayFailStatus {
  CANCEL = 'cancel',
  FAIL = 'fail',
}
enum FreeFrom {
  CANCEL = '二次支付取消',
  REFUSE = '残忍拒绝',
}

@Component
export default class StayStrategy extends Vue {
  // 截流v1.1

  showRepayModal = false;
  strategyData = {};

  mounted() {
    eventBus.$on('track', this.handleStrategyTracker);
  }

  initStrategyTracker() {
    // 普通截2
    if (this.$route.query.strategy) {
      this.handleStrategyTracker('landingpage_paid_page_view', {
        load_duration: Date.now() - window.performance.timing.navigationStart,
      });
    }

    // 截2 对应0元
    if (this.$route.query.isStrategyFree) {
      this.handleStrategyFreeTracker('landingpage_free_page_view', {
        load_duration: Date.now() - window.performance.timing.navigationStart,
      });
    }
  }

  handleStrategyTracker(event: string, data = {}) {
    if (!this.$route.query.strategy) {
      return;
    }
    this.sendStrategyTracker(event, data);
  }

  // 截2 0元
  handleStrategyFreeTracker(event: string, data = {}) {
    if (!this.$route.query.isStrategyFree) {
      return;
    }
    this.sendStrategyTracker(event, data);
  }

  sendStrategyTracker(event: string, data = {}) {
    const { From, FromVersion, strategy, _cc } = this.$route.query;

    const info: any = {
      from: From || '',
      from_version: FromVersion || '',
      act_version: strategy,
      channel: _cc,
      ...commonAttr,
      ...data,
    };
    if (needPrice.includes(event)) {
      info.price = this.pageConfig.sensor_data.actual_price;
    }
    trackerLoaded.then(tracker => {
      tracker.track(event, info);
    });
  }

  onPayError(e: { result: PayFailStatus }) {
    if (e?.result === PayFailStatus.CANCEL) {
      this.handleStrategyTracker('landingpage_paid_pay_status', {
        payment_status: '取消',
      });
      if (
        ['single', 'single-auth'].includes(this.$route.name) &&
        !!this.pageConfig.strategy
      ) {
        // 目前仅针对single页取消支付进行拦截
        this.handleTriggerStayStrategy();
      }
    } else {
      this.handleStrategyTracker('landingpage_paid_pay_status', {
        payment_status: '失败',
      });
    }
  }
  // 二次弹窗展示优惠券？
  handleTriggerStayStrategy() {
    this.getModalInfo();
    this.showRepayModal = true;
    this.handleStrategyTracker('landingpage_paid_popup', {
      trigger_method: '首次支付取消',
    });
  }
  async getModalInfo() {
    try {
      const { data } = await window.apis.getStrategy({
        strategy: this.pageConfig.strategy,
      });
      data && this.$set(this, 'strategyData', data);
    } catch (e) { }
  }

  handleTriggerFree(triggerMethod: FreeFrom) {
    FreeModal.init({
      ...this.strategyData,
      id: this.pageConfig.strategy,
      triggerMethod,
    });
    FreeModal.show();
  }
  // 截留逻辑，用户取消领取福利
  onCloseRepay() {
    this.handleStrategyTracker('landingpage_paid_popup_quit', {
      button_name: '关闭',
    });
    this.handleCancelRepay(FreeFrom.REFUSE);
  }

  handleCancelRepay(triggerMethod: FreeFrom) {
    this.handleStrategyTracker('landingpage_free_popup', {
      trigger_method: triggerMethod,
    });
    this.showRepayModal = false;

    // 展示免费弹窗
    this.handleTriggerFree(triggerMethod);
  }
  // 用户领取福利事件
  @promiseLock
  handleRepay() {
    this.handleStrategyTracker('landingpage_paid_popup_enroll_click', {
      button_name: '开心收下',
    });
    this.handleStrategyTracker('landingpage_paid_popup_prepay');

    return handlePayment(
      this.productionId,
      {
        channel: this.payConfig.channel,
        mobile: this.pageConfig?.mobile,
      },
      this.priceCountDown > 0
        ? { ...this.$route.query, use_coupon: false }
        : { ...this.$route.query }
    )
      .then(() => {
        this.isShowMobileValid = false;
        this.eleObserver && this.eleObserver.unobserve();
        this.showRepayModal = false;

        this.handleStrategyTracker('landingpage_paid_popup_pay_status', {
          payment_status: '成功',
        });
        this.handleStrategyTracker('landingpage_enroll', {
          production_id: this.productionId,
          source_path: '8.9元挽留弹窗',
        });

        return this.freshBottomConfig();
      })
      .catch((e: any) => {
        if (e?.result === PayFailStatus.CANCEL) {
          this.handleCancelRepay(FreeFrom.CANCEL);
          this.handleStrategyTracker('landingpage_paid_popup_pay_status', {
            payment_status: '取消',
          });
        } else {
          // 在finally上报失败，只能分开写
          this.handleStrategyTracker('landingpage_paid_popup_pay_status', {
            payment_status: '失败',
          });
        }
      });
  }
}
